import { render, staticRenderFns } from "./loansummary.vue?vue&type=template&id=2456d8c3&scoped=true"
import script from "./loansummary.vue?vue&type=script&lang=js"
export * from "./loansummary.vue?vue&type=script&lang=js"
import style0 from "./loansummary.vue?vue&type=style&index=0&id=2456d8c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2456d8c3",
  null
  
)

export default component.exports